import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import RangeFilterView from './RangeFilterView';

interface IProps {
  name: string;
  filter: Record<string, any>;
  values?: Record<string, any>;
  value?: string;
  checkboxProps?: Record<string, any>;
  label?: string;
  onChange?;
}

const RangeFilter = ({ onChange, checkboxProps, value }: IProps) => {
  const [fromValue, setFromValue] = useState('');
  const [toValue, setToValue] = useState('');
  const [checkboxValue, setCheckboxValue] = useState('');
  const [error, setError] = useState('');

  const { t } = useTranslation();

  const onCheckboxClick = (event) => {
    const value = event.target.checked ? event.target.value : null;

    setFromValue('');
    setToValue('');
    setError('');

    setCheckboxValue(value);
    onChange(value);
  };

  useEffect(() => {
    if (fromValue && toValue) {
      setError(Number(fromValue) > Number(toValue) ? t('errorFromToRange') : '');
      onChange(`${fromValue}|${toValue}`);

      return;
    }

    if ((fromValue || toValue) && value) {
      setError(t('errorFromToRequired'));

      return;
    }

    setError('');
  }, [fromValue, toValue]);

  useEffect(() => {
    if (!value) {
      setFromValue('');
      setToValue('');
      setCheckboxValue('');
      setError('');

      return;
    }
  }, [value]);

  return (
    <RangeFilterView
      fromValue={fromValue}
      toValue={toValue}
      setFromValue={setFromValue}
      setToValue={setToValue}
      onCheckboxClick={onCheckboxClick}
      checkboxProps={checkboxProps}
      checkboxValue={checkboxValue}
      error={error}
    />
  );
};

export default RangeFilter;
